export class HwLogDto {
    Subsystem: string;
    Sysdat: string | null;
    Subscriber: string;
    HotelId: number | null;
    ClassName: string;
    MethodName: string;
    Message: string;
    LogLevel: string;
    UserName: string;
    SData: any;
}